
import { StringHelpers } from "../helpers/string-helpers";
import { IChartContainer } from "../models/base/chart-container.interface";
import { IComponent } from "./component.interface";

export class ScalingResetButtonComponent implements IComponent {
    public id = StringHelpers.newGuid();;

    private element: HTMLElement;
    private base: IChartContainer;

    constructor(el: HTMLElement, base: IChartContainer) {
        this.element = el;
        this.base = base;
        this.base.tiChartSeries?.subscribeExtremeChange(this.id, () => {
            this.toggleButton()
        });
        this.base.tiChartSeries?.subscribeRedrawChange(this.id, () => {
            this.toggleButton()
        });

        this.onClick();
    }

    private onClick() {
        this.element.addEventListener('click', () => {
            if (!this.base.tiChartSeries) {
                return;
            }

            this.base.tiChartSeries.highChartAxisBuilder.redrawYAxis = true;
            this.base.tiChartSeries.highChartAxisBuilder.manualExpandYAxisScale = false;
            this.base.tiChartSeries.yAxisMoved = false;
            this.base.tiChartSeries.highStockChart?.yAxis?.[0].setExtremes(null, null)
            setTimeout(() => {
                this.base.tiChartSeries?.highChartAxisBuilder.buildAxisComponents();
            }, 50);
        });
    }

    private toggleButton() {
        setTimeout(() => {
            if (!this.base.tiChartSeries) {
                return;
            }

            let shouldDisplayButton = this.base.tiChartSeries.highChartAxisBuilder.manualExpandYAxisScale;
            if (shouldDisplayButton) {
                this.element.classList.remove('hidden');
            } else {
                this.element.classList.add('hidden');
            }
        }, 150);
    }
}